/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "refund": {
            "nested": {
              "RefundError": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "INVALID_STATE": 1,
                  "RECORD_NOT_FOUND": 2,
                  "OTHER": 3,
                  "PENDING_CAPTURE": 4,
                  "CARD_PRESENCE_REQUIRED": 5,
                  "RESERVATION_DECLINED": 6,
                  "CARD_MISMATCH": 7,
                  "ZERO_AMOUNT_GIVEN": 8,
                  "INVALID_AMOUNT": 27,
                  "INVALID_FEES": 9,
                  "NOT_ALLOWED_BY_TENDER": 10,
                  "RESERVATION_DECLINED_WITH_NO_RECORD": 11,
                  "REQUESTED_AMOUNT_EXCEEDS_AVAILABLE_AMOUNT": 12,
                  "CURRENCY_MISMATCH": 13,
                  "UNLINKED_REFUNDS_NOT_ALLOWED_BY_TENDER": 14,
                  "RISK_CHECKS_FAILED": 15,
                  "RISK_2FA_DISABLED": 16,
                  "RISK_NO_LINKED_BANK_ACCOUNT": 17,
                  "RISK_NO_PREVIOUS_CARD_PAYMENTS": 18,
                  "UNROUTABLE_REFUND": 19,
                  "INSUFFICIENT_MERCHANT_BALANCE": 20,
                  "REFUND_IMPLIES_EXCESSIVE_OVERCAPTURE": 21,
                  "REFUND_DESTINATION_HAS_MISMATCHED_CURRENCY": 22,
                  "REFUND_DESTINATION_IN_INVALID_STATE": 23,
                  "REQUESTED_AMOUNT_EXCEEDS_REFUND_DESTINATION_LIMIT": 24,
                  "REQUESTED_AMOUNT_EXCEEDS_REFUND_DESTINATION_PERIODIC_LIMIT": 28,
                  "REQUEST_DESTINATION_COMPLIANCE_FAILURE": 25,
                  "REFUND_DESTINATION_NOT_FOUND": 26,
                  "REQUESTED_AMOUNT_EXCEEDS_RECIPIENT_LIMIT": 29,
                  "REQUESTED_AMOUNT_EXCEEDS_MERCHANT_LIMIT": 30,
                  "RISK_DECLINE": 31
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.refund?.nested?.RefundError) {
  $root.addJSON(jsonData);
}

/**
 * The reason a refund was declined, which may come from either Square's payment stack or an
 * external vendor.
 *
 * SOURCE RefundError @ squareup/payments/refund.proto at 10:1
 */
export const RefundError = $root.lookupEnum('squareup.payments.refund.RefundError').values;